/**
 * Frontend side of GitHub OAuth sessions.
 * The backend redirects back to the editor with #session={token}; the token is
 * kept in localStorage and sent as `Authorization: Bearer` by RemoteProjectStorage.
 * Design: ld-editor-backend/docs/GITHUB_OAUTH_PLAN.md
 */

const SESSION_KEY = 'ld-session';

export function getSession(): string | null {
  return localStorage.getItem(SESSION_KEY);
}

export function clearSession(): void {
  localStorage.removeItem(SESSION_KEY);
}

/**
 * If the URL hash carries a fresh session from the OAuth callback
 * (#session=...), store it and strip the hash. Call once on boot, before any
 * storage requests. Returns true if a session was captured.
 */
export function captureSessionFromHash(): boolean {
  const match = window.location.hash.match(/^#session=(.+)$/);
  if (!match) return false;
  localStorage.setItem(SESSION_KEY, match[1]);
  history.replaceState(null, '', window.location.pathname + window.location.search);
  return true;
}

/**
 * Build the backend login URL that starts the OAuth flow and returns to the
 * current page. apiBaseUrl may be absolute (https://backend.pages.dev/api) or
 * relative (/api) — the /auth routes live on the same origin as the API.
 */
export function buildLoginUrl(apiBaseUrl: string): string {
  const backendOrigin = new URL(apiBaseUrl, window.location.origin).origin;
  const redirect = window.location.origin + window.location.pathname;
  return `${backendOrigin}/auth/login?redirect=${encodeURIComponent(redirect)}`;
}
